'use strict';

var cov_1cb4db29fc = function () {
  var path = '/home/rwaltenberg/Projects/moneycounter/src/app/bill/bill.js',
      hash = '076e2ad59774523daab352c349646f6c710ee9e5',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/rwaltenberg/Projects/moneycounter/src/app/bill/bill.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 0
        },
        end: {
          line: 40,
          column: 5
        }
      },
      '1': {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 14,
          column: 23
        }
      },
      '2': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 19
        }
      },
      '3': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 24,
          column: 8
        }
      },
      '4': {
        start: {
          line: 18,
          column: 26
        },
        end: {
          line: 18,
          column: 47
        }
      },
      '5': {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 29
        }
      },
      '6': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 31
        }
      },
      '7': {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 90
        }
      },
      '8': {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 51
        }
      },
      '9': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 29,
          column: 8
        }
      },
      '10': {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 50
        }
      },
      '11': {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 29
        }
      },
      '12': {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 38,
          column: 8
        }
      },
      '13': {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 44
        }
      },
      '14': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 37,
          column: 9
        }
      },
      '15': {
        start: {
          line: 35,
          column: 23
        },
        end: {
          line: 35,
          column: 59
        }
      },
      '16': {
        start: {
          line: 36,
          column: 10
        },
        end: {
          line: 36,
          column: 37
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 25
          }
        },
        loc: {
          start: {
            line: 17,
            column: 30
          },
          end: {
            line: 24,
            column: 7
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 26,
            column: 23
          },
          end: {
            line: 26,
            column: 24
          }
        },
        loc: {
          start: {
            line: 26,
            column: 33
          },
          end: {
            line: 29,
            column: 7
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 31,
            column: 27
          },
          end: {
            line: 31,
            column: 28
          }
        },
        loc: {
          start: {
            line: 31,
            column: 33
          },
          end: {
            line: 38,
            column: 7
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 23,
            column: 20
          },
          end: {
            line: 23,
            column: 36
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 23,
            column: 20
          },
          end: {
            line: 23,
            column: 31
          }
        }, {
          start: {
            line: 23,
            column: 35
          },
          end: {
            line: 23,
            column: 36
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 39
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 34
          }
        }, {
          start: {
            line: 27,
            column: 38
          },
          end: {
            line: 27,
            column: 39
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1cb4db29fc.s[0];
/* global tinycolor */

angular.module('app').component('bill', {
  templateUrl: 'app/bill/bill.html',
  bindings: {
    value: '@',
    color: '@',
    amount: '<',
    onAmountChanged: '&'
  },
  controller: function controller() {
    var ctrl = (++cov_1cb4db29fc.s[1], this);
    ++cov_1cb4db29fc.s[2];
    ctrl.sum = 0;

    ++cov_1cb4db29fc.s[3];
    ctrl.$onChanges = function () {
      ++cov_1cb4db29fc.f[0];

      var fontColor = (++cov_1cb4db29fc.s[4], tinycolor(ctrl.color));
      ++cov_1cb4db29fc.s[5];
      fontColor.darken(50);
      ++cov_1cb4db29fc.s[6];
      fontColor.saturate(10);

      ++cov_1cb4db29fc.s[7];
      ctrl.bgcolor = { "background-color": ctrl.color, "color": fontColor.toHexString() };
      ++cov_1cb4db29fc.s[8];
      ctrl.sum = ((++cov_1cb4db29fc.b[0][0], ctrl.amount) || (++cov_1cb4db29fc.b[0][1], 0)) * ctrl.value;
    };

    ++cov_1cb4db29fc.s[9];
    ctrl.addAmount = function (amount) {
      ++cov_1cb4db29fc.f[1];
      ++cov_1cb4db29fc.s[10];

      ctrl.amount = ((++cov_1cb4db29fc.b[1][0], ctrl.amount) || (++cov_1cb4db29fc.b[1][1], 0)) + amount;
      ++cov_1cb4db29fc.s[11];
      ctrl.amountChanged();
    };

    ++cov_1cb4db29fc.s[12];
    ctrl.amountChanged = function () {
      ++cov_1cb4db29fc.f[2];
      ++cov_1cb4db29fc.s[13];

      ctrl.sum = ctrl.amount * ctrl.value;

      ++cov_1cb4db29fc.s[14];
      if (ctrl.onAmountChanged) {
        ++cov_1cb4db29fc.b[2][0];

        var args = (++cov_1cb4db29fc.s[15], { amount: ctrl.amount, sum: ctrl.sum });
        ++cov_1cb4db29fc.s[16];
        ctrl.onAmountChanged(args);
      } else {
        ++cov_1cb4db29fc.b[2][1];
      }
    };
  }
});